export const BORDER_COLORS = [
    "#4a90e2",
    "#72c799",
    "#e79cff",
    "#9ce7ff",
    "#FF5733",
    "#caff00",
];
export const AREA_COLORS = [
    "rgba(74, 144, 226, 0.2)",
    "rgba(34, 193, 195, 0.2)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(0, 29, 255, 0.2)",
    "rgba(233, 30, 99, 0.2)",
    "rgba(255, 193, 7, 0.2)",
];

export const FILE_SELECTION_COLORS = [
    "rgba(179, 180, 179, 1)",
    "rgba(34, 193, 195, 1)",
    "rgba(99, 71, 125, 1)",
    "rgba(175, 158, 69, 1)",
    "rgba(127, 195, 161, 1)",
    "rgba(181, 122, 15, 1)",
];